import {
  Table,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
} from "@mui/material";
import * as React from "react";
import { Link } from "react-router-dom";
// import ButtonGroup from "@mui/material/ButtonGroup";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import "../table.scss";
import useAccountListingHelper from "./helper";
import NoInternetAlert from "../../noInternetAlert";
import { IMAGES, Paths } from "../../../common/constants";
import ConfirmationModal from "../../modal/confirmationModal";
import { formatUnixToDate, getIndexOfData } from "../../../common/utils";
import { BankAccount } from "../../../pages/accounts-management/services/type";

const AccountListing = () => {
  const {
    limit,
    pageNo,
    accountListing,
    isAccountsPage,
    openSetPrimaryConfirmationDialog,

    handlePrimaryClick,
    handleSetPrimaryAccount,
    handleCloseSetPrimaryConfirmationDialog,
  } = useAccountListingHelper();
  return (
    <div className="customTableWrapper">
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Serial No.</TableCell>
              <TableCell align="center">Bank Account Name</TableCell>
              <TableCell align="center">Bank Name</TableCell>
              <TableCell align="center">Account Type</TableCell>
              <TableCell align="center">Added On</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {accountListing && accountListing.length ? (
              accountListing
                .slice() // Create a copy to avoid mutating the original array
                .sort(
                  (a: BankAccount, b: BankAccount) =>
                    (b.isSelected ? 1 : 0) - (a.isSelected ? 1 : 0),
                ) // Sort based on isSelected
                .map((row: BankAccount, index: number) => (
                  <TableRow key={row.bankAccountId}>
                    <TableCell component="th" scope="row">
                      <span className="tableOrder">
                        {getIndexOfData(pageNo, limit, index + 1)}
                      </span>
                    </TableCell>
                    <TableCell align="center">
                      {row?.name ? (
                        !isAccountsPage ? (
                          <>{row.name}</>
                        ) : (
                          <Link
                            onClick={() =>
                              localStorage.setItem(
                                "account-details",
                                JSON.stringify(row),
                              )
                            }
                            to={`${Paths.ACCOUNT_DETAILS}/${row.bankAccountId}`}
                          >
                            {row.name}
                          </Link>
                        )
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {row?.bankName ? (
                        <>
                          {row.bankName}
                          {row.isSelected === "1" && (
                            <span className="primaryText"> (PRIMARY)</span>
                          )}
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {row?.accountType ? row?.accountType : "-"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.createdDate
                        ? formatUnixToDate(row.createdDate)
                        : "-"}
                    </TableCell>
                    <TableCell align="center">
                      <div className="tableBtnActionWrapper">
                        {/* Action Button Logic */}
                        {(() => {
                          // @ts-ignore
                          const isDisabled = row?.isSelected === "1";

                          return (
                            <Button
                              color="primary"
                              variant="contained"
                              disabled={isDisabled}
                              className="action-button"
                              onClick={() =>
                                handlePrimaryClick("Mark as Primary", row)
                              }
                            >
                              Mark as Primary
                            </Button>
                          );
                          // }
                          // return (
                          //   <ButtonGroup variant="contained" color="primary">
                          //     <Button
                          //       disabled={isEditAccess}
                          //       className="action-button primary-action-btn"
                          //       onClick={() =>
                          //         handlePrimaryClick(primaryAction, row)
                          //       }
                          //     >
                          //       {primaryAction}
                          //     </Button>
                          //     <Button
                          //       size="small"
                          //       id="basic-button"
                          //       disabled={isEditAccess}
                          //       className="action-button secondary-action-btn"
                          //       onClick={(e) => handleBtnClick(e, row)}
                          //     >
                          //       <ArrowDropDownIcon />
                          //     </Button>
                          //   </ButtonGroup>
                          // );
                        })()}
                        {/* <Menu
                          open={open}
                          id="basic-menu nitin-menu"
                          anchorEl={anchorEl}
                          onClose={handleClose}
                          className="tableMenuWrapper"
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          {getActionsFromSelectedAccount(selectedAccount).map(
                            (action) => (
                              <MenuItem
                                key={action}
                                onClick={() => handleMenuItemClick(action, row)}
                              >
                                {action}
                              </MenuItem>
                            )
                          )}
                        </Menu> */}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <NoInternetAlert
                    title={"No account added yet, please add new account."}
                    heading=""
                    subText=""
                    imageSrc={IMAGES.NoData}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* <ConfirmationModal
        heading="Delete"
        noBtnTxt="Cancel"
        yesBtnTxt="Delete"
        image={IMAGES.deleteIcon}
        onClick={handleDeleteAccount}
        open={openDeleteConfirmationDialog}
        handleClose={handleCloseDeleteConfirmationDialog}
        content="Are you sure you want to delete this account?"
      /> */}

      <ConfirmationModal
        heading=""
        noBtnTxt="Cancel"
        yesBtnTxt="Mark"
        image={IMAGES.check}
        onClick={handleSetPrimaryAccount}
        open={openSetPrimaryConfirmationDialog}
        handleClose={handleCloseSetPrimaryConfirmationDialog}
        content="Are you sure you want to mark this account as primary?"
      />
    </div>
  );
};

export default AccountListing;
